// extracted by css-extract-rspack-plugin
export default {"heading4":"Heading4_heading4__ZNg-m"};